/* Fits Well, Fits Right — tab 切换 + Banner 轮播 + PC 商品横向浏览
   作用域按 section 根节点隔离，同页多实例互不影响。 */
(function () {
  'use strict';

  var MODULE_KEY = '__reibiiFitsWellModule';
  if (window[MODULE_KEY]) {
    window[MODULE_KEY].initAll();
    return;
  }

  var BANNER_INTERVAL = 5000;

  /* ---------------- Banner ---------------- */

  function initBanner(banner) {
    var track = banner.querySelector('[data-fits-banner-track]');
    if (!track) return null;

    var slides = track.querySelectorAll('.fits-banner-slide');
    banner.setAttribute('data-banner-count', String(slides.length));
    banner.classList.toggle('fits-banner--multiple', slides.length > 1);
    banner.hidden = slides.length === 0;
    if (slides.length < 2) return null;

    var dotsHost = banner.querySelector('[data-fits-banner-dots]');
    var prev = banner.querySelector('[data-fits-banner-prev]');
    var next = banner.querySelector('[data-fits-banner-next]');
    var index = 0;
    var timer = null;
    var scrollTimer = null;
    var paused = false;

    if (dotsHost) {
      dotsHost.textContent = '';
      for (var d = 0; d < slides.length; d++) {
        var dot = document.createElement('button');
        dot.className = 'fits-banner-dot' + (d === 0 ? ' is-active' : '');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Go to banner ' + (d + 1));
        dot.setAttribute('data-fits-banner-dot', String(d));
        dotsHost.appendChild(dot);
      }
    }
    var dots = banner.querySelectorAll('[data-fits-banner-dot]');

    function goTo(target, smooth) {
      index = (target + slides.length) % slides.length;
      track.scrollTo({
        left: track.clientWidth * index,
        behavior: smooth === false ? 'auto' : 'smooth',
      });
      syncDots();
    }

    function syncDots() {
      for (var i = 0; i < dots.length; i++) {
        dots[i].classList.toggle('is-active', i === index);
      }
    }

    function readIndexFromScroll() {
      if (!track.clientWidth) return;
      var current = Math.round(track.scrollLeft / track.clientWidth);
      if (current !== index) {
        index = current;
        syncDots();
      }
    }

    function start() {
      stop();
      if (paused) return;
      timer = window.setInterval(function () {
        goTo(index + 1);
      }, BANNER_INTERVAL);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    function onPreviousClick() {
      goTo(index - 1);
      start();
    }

    function onNextClick() {
      goTo(index + 1);
      start();
    }

    function onDotClick(event) {
      var dot = event.target.closest('[data-fits-banner-dot]');
      if (!dot || !dotsHost.contains(dot)) return;
      goTo(parseInt(dot.getAttribute('data-fits-banner-dot'), 10));
      start();
    }

    function onScroll() {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(readIndexFromScroll, 120);
    }

    function onMouseEnter() {
      paused = true;
      stop();
    }

    function onMouseLeave() {
      paused = false;
      start();
    }

    function onFocusIn() {
      paused = true;
      stop();
    }

    function onFocusOut() {
      paused = false;
      start();
    }

    function destroy() {
      stop();
      window.clearTimeout(scrollTimer);
      if (prev) prev.removeEventListener('click', onPreviousClick);
      if (next) next.removeEventListener('click', onNextClick);
      if (dotsHost) dotsHost.removeEventListener('click', onDotClick);
      track.removeEventListener('scroll', onScroll);
      banner.removeEventListener('mouseenter', onMouseEnter);
      banner.removeEventListener('mouseleave', onMouseLeave);
      banner.removeEventListener('focusin', onFocusIn);
      banner.removeEventListener('focusout', onFocusOut);
    }

    if (prev) prev.addEventListener('click', onPreviousClick);
    if (next) next.addEventListener('click', onNextClick);
    if (dotsHost) dotsHost.addEventListener('click', onDotClick);
    track.addEventListener('scroll', onScroll, { passive: true });
    banner.addEventListener('mouseenter', onMouseEnter);
    banner.addEventListener('mouseleave', onMouseLeave);
    banner.addEventListener('focusin', onFocusIn);
    banner.addEventListener('focusout', onFocusOut);

    return {
      start: start,
      stop: stop,
      reset: function () {
        goTo(0, false);
      },
      destroy: destroy,
    };
  }

  /* ---------------- Banner 舞台 ----------------
     把各 Tab 面板里的 banner 图搬进一条常驻轨道，滑动或点箭头即联动 Tab 与商品。
     轨道结构（N 个 Tab）：[克隆末张][0][1]…[N-1][克隆首张]，共 N+2 格。
     停在克隆格时静默跳回对应真实格，从而实现无缝循环。 */

  function initBannerStage(root, panels, onChange) {
    var stage = root.querySelector('[data-fits-banner-stage]');
    var track = stage && stage.querySelector('[data-fits-banner-stage-track]');
    if (!stage || !track) return null;

    /* 每个 Tab 取第一张 banner——本组件的关系是 1 Tab : 1 Banner : 1 组商品 */
    var slides = [];
    panels.forEach(function (panel, i) {
      var slide = panel.querySelector('.fits-banner-slide');
      if (!slide) return;
      slide.setAttribute('data-fits-stage-index', String(i));
      track.appendChild(slide);
      slides.push(slide);
    });
    if (!slides.length) return null;

    var count = slides.length;
    var loop = count > 1;
    var prev = stage.querySelector('[data-fits-stage-prev]');
    var next = stage.querySelector('[data-fits-stage-next]');

    /* 首尾克隆：克隆体不参与 Tab 映射，aria-hidden 且移出 tab 序列 */
    if (loop) {
      var head = slides[count - 1].cloneNode(true);
      var tail = slides[0].cloneNode(true);
      [head, tail].forEach(function (clone) {
        clone.removeAttribute('data-fits-stage-index');
        clone.removeAttribute('id');
        clone.setAttribute('aria-hidden', 'true');
        clone.classList.add('fits-banner-slide--clone');
        var focusable = clone.querySelectorAll('a, button, input, [tabindex]');
        for (var f = 0; f < focusable.length; f++) focusable[f].setAttribute('tabindex', '-1');
      });
      track.insertBefore(head, track.firstChild);
      track.appendChild(tail);
    } else {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
    }

    stage.hidden = false;
    root.classList.add('fits-stage-on');

    var currentIndex = 0;
    var currentPos = loop ? 1 : 0;
    var scrollTimer = null;
    var glideTimer = null;
    var normalizeTimer = null;

    function posOf(index) {
      return loop ? index + 1 : index;
    }

    function realOf(pos) {
      if (!loop) return Math.max(0, Math.min(count - 1, pos));
      if (pos <= 0) return count - 1;
      if (pos >= count + 1) return 0;
      return pos - 1;
    }

    /* 停在克隆格后瞬移回真实格：关掉吸附再改 scrollLeft，否则会与吸附动画打架 */
    function jumpTo(pos) {
      var snap = track.style.scrollSnapType;
      var behavior = track.style.scrollBehavior;
      track.style.scrollSnapType = 'none';
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = pos * track.clientWidth;
      void track.offsetWidth;
      track.style.scrollSnapType = snap;
      track.style.scrollBehavior = behavior;
    }

    /* behavior:'smooth' 在部分环境（无头浏览器、内嵌 WebView、系统关闭动效）是空操作，
       那时轨道会原地不动而 Tab 已经切走。所以动画只当增强：发出平滑滚动后留一个兜底，
       若到点位置完全没变（说明动画根本没起步）就直接落位。 */
    function scrollToPos(pos, smooth) {
      var left = pos * track.clientWidth;
      window.clearTimeout(glideTimer);
      if (!smooth) {
        track.scrollLeft = left;
        return;
      }
      var from = track.scrollLeft;
      track.scrollTo({ left: left, behavior: 'smooth' });
      glideTimer = window.setTimeout(function () {
        if (track.scrollLeft === from && Math.abs(from - left) > 2) {
          track.scrollLeft = left;
        }
      }, 400);
    }

    /* 6 张 banner 现在并排在一条横向滚动轨道里，视口外的那些仍是 lazy。
       把当前格及左右相邻格提升为 eager，避免滑过去时图还没解码出来是白的。 */
    function preloadAround(pos) {
      for (var i = pos - 1; i <= pos + 1; i++) {
        var slide = track.children[i];
        if (!slide) continue;
        var imgs = slide.querySelectorAll('img[loading="lazy"]');
        for (var n = 0; n < imgs.length; n++) imgs[n].setAttribute('loading', 'eager');
      }
    }

    function notify(index) {
      preloadAround(posOf(index));
      if (index === currentIndex) return;
      currentIndex = index;
      if (onChange) onChange(index);
    }

    /* 程序化切换（箭头/Tab）目标已知，落到克隆格后自行定时归位，
       不依赖 scroll 事件——手指滑动才需要靠 scroll 事件反推位置。 */
    function setPos(pos, smooth) {
      currentPos = pos;
      scrollToPos(pos, smooth);
      notify(realOf(pos));
      window.clearTimeout(normalizeTimer);
      if (loop && (pos === 0 || pos === count + 1)) {
        normalizeTimer = window.setTimeout(function () {
          currentPos = posOf(realOf(pos));
          jumpTo(currentPos);
        }, smooth ? 520 : 60);
      }
    }

    function step(delta) {
      /* 连点时可能仍停在克隆格上，先归一到等价的真实格，避免位置越界累加 */
      if (loop && (currentPos === 0 || currentPos === count + 1)) {
        currentPos = posOf(realOf(currentPos));
        jumpTo(currentPos);
      }
      var target = currentPos + delta;
      if (!loop && (target < 0 || target > count - 1)) return;
      setPos(target, true);
    }

    function onScrollSettle() {
      var width = track.clientWidth;
      if (!width) return;
      var pos = Math.round(track.scrollLeft / width);
      currentPos = pos;
      var real = realOf(pos);
      notify(real);
      if (loop && (pos === 0 || pos === count + 1)) {
        currentPos = posOf(real);
        jumpTo(currentPos);
      }
    }

    function onScroll() {
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(onScrollSettle, 140);
    }

    function onPrevClick() {
      step(-1);
    }

    function onNextClick() {
      step(1);
    }

    if (prev) prev.addEventListener('click', onPrevClick);
    if (next) next.addEventListener('click', onNextClick);
    track.addEventListener('scroll', onScroll, { passive: true });

    /* 初始定位到第一张真实图，不能带动画 */
    jumpTo(currentPos);
    preloadAround(currentPos);

    return {
      /* 由 Tab 点击驱动：相邻滑过去，跨多张直接瞬移，避免长距离滚动卡顿 */
      goTo: function (index) {
        var target = posOf(index);
        /* 仅当轨道确实已经停在目标格才跳过；否则（例如滑动被打断导致
           位置与高亮不一致）即使 index 没变也要把轨道拉回去重新对齐。 */
        var atTarget = Math.abs(track.scrollLeft - target * track.clientWidth) < 2;
        if (index === currentIndex && atTarget) return;
        var smooth = Math.abs(target - currentPos) === 1;
        currentIndex = index;
        currentPos = target;
        scrollToPos(target, smooth);
      },
      indexOfNode: function (node) {
        var slide = node && node.closest ? node.closest('[data-fits-stage-index]') : null;
        if (!slide) return -1;
        var i = parseInt(slide.getAttribute('data-fits-stage-index'), 10);
        return isNaN(i) ? -1 : i;
      },
      resize: function () {
        jumpTo(currentPos);
      },
      destroy: function () {
        window.clearTimeout(scrollTimer);
        window.clearTimeout(glideTimer);
        window.clearTimeout(normalizeTimer);
        if (prev) prev.removeEventListener('click', onPrevClick);
        if (next) next.removeEventListener('click', onNextClick);
        track.removeEventListener('scroll', onScroll);
        root.classList.remove('fits-stage-on');
        stage.hidden = true;
      },
    };
  }

  /* ---------------- 商品轮播 ----------------
     轨道交给 halo.slide-custom.js（Slick）。面板在隐藏状态下初始化会算出 0 宽，
     因此每次切到某个 Tab 后都要对该面板的轨道补一次 setPosition。 */

  function refreshPanelSlider(panel) {
    if (!panel || !window.jQuery) return;
    window.jQuery(panel)
      .find('[slide-custom-init]')
      .each(function () {
        var $track = window.jQuery(this);
        if ($track.hasClass('slick-initialized')) $track.slick('setPosition');
      });
  }

  /* ---------------- Section ---------------- */

  function initSection(root) {
    if (root._fitsWellReady) return root._fitsWellDestroy;

    var panelsHost = root.querySelector('[data-fits-panels]');
    var panels = panelsHost
      ? Array.prototype.slice.call(panelsHost.querySelectorAll(':scope > [data-fits-panel]'))
      : [];
    var indicator = root.querySelector('[data-fits-tab-indicator]');
    var tabsRow = root.querySelector('[data-fits-tabs]');
    if (!panels.length || !tabsRow) return null;

    /* Theme Block 的 settings 在 section 上下文不可读，Tab 按钮据面板的 data-tab-name 生成 */
    var sectionId = root.getAttribute('data-section-id') || '0';
    var tabs = panels.map(function (panel, i) {
      panel.id = 'fits-panel-' + sectionId + '-' + i;
      panel.setAttribute('data-fits-panel-index', String(i));

      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'fits-tab';
      tab.setAttribute('role', 'tab');
      tab.id = 'fits-tab-' + sectionId + '-' + i;
      tab.setAttribute('aria-controls', panel.id);
      tab.setAttribute('aria-selected', 'false');
      tab.setAttribute('data-fits-tab', String(i));
      tab.textContent = panel.getAttribute('data-tab-name') || 'Tab';
      tabsRow.insertBefore(tab, indicator);

      panel.setAttribute('aria-labelledby', tab.id);
      return tab;
    });
    root.classList.add('fits-js');
    root._fitsWellReady = true;

    var banners = [];
    var tabClickHandlers = [];
    var resizeTimer = null;
    var destroyed = false;

    /* 舞台优先：接管后各面板内的 banner 不再单独轮播，避免两套轮播互相打架 */
    var syncingFromStage = false;
    var stage = initBannerStage(root, panels, function (index) {
      syncingFromStage = true;
      activate(index);
      syncingFromStage = false;
    });

    if (!stage) {
      panels.forEach(function (panel) {
        var banner = panel.querySelector('[data-fits-banner]');
        banners.push(banner ? initBanner(banner) : null);
      });
    }

    function moveIndicator(tab) {
      if (!indicator || !tab || !tabsRow) return;
      indicator.style.width = '';
      var left = tab.offsetLeft + tab.offsetWidth / 2;
      indicator.style.transform = 'translateX(' + left + 'px) translateX(-50%)';
    }

    function activate(index, focusTab) {
      if (destroyed || index < 0 || index >= tabs.length) return;

      tabs.forEach(function (tab, i) {
        var active = i === index;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      panels.forEach(function (panel, i) {
        var active = i === index;
        panel.classList.toggle('is-active', active);
        panel.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      banners.forEach(function (banner, i) {
        if (!banner) return;
        if (i === index) {
          banner.start();
        } else {
          banner.stop();
        }
      });

      /* 面板刚从 display:none 变为可见，等一帧再让 Slick 重新量宽 */
      var activePanel = panels[index];
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(function () {
          refreshPanelSlider(activePanel);
        });
      } else {
        refreshPanelSlider(activePanel);
      }

      /* 来自舞台的切换不再回推舞台，否则会自激循环 */
      if (stage && !syncingFromStage) stage.goTo(index);

      moveIndicator(tabs[index]);

      if (tabs[index] && tabsRow) {
        var tab = tabs[index];
        var overflowLeft = tab.offsetLeft - tabsRow.scrollLeft;
        var overflowRight = overflowLeft + tab.offsetWidth - tabsRow.clientWidth;
        if (overflowLeft < 0) {
          tabsRow.scrollBy({ left: overflowLeft - 16, behavior: 'smooth' });
        } else if (overflowRight > 0) {
          tabsRow.scrollBy({ left: overflowRight + 16, behavior: 'smooth' });
        }
      }

      if (focusTab && tabs[index]) tabs[index].focus();
    }

    tabs.forEach(function (tab, i) {
      var onTabClick = function () {
        if (tab.classList.contains('is-active')) return;
        activate(i);
      };
      tabClickHandlers.push(onTabClick);
      tab.addEventListener('click', onTabClick);
    });

    function refresh() {
      if (destroyed) return;
      var activeIndex = 0;
      tabs.forEach(function (tab, i) {
        if (tab.classList.contains('is-active')) activeIndex = i;
      });
      moveIndicator(tabs[activeIndex]);
      refreshPanelSlider(panels[activeIndex]);
      if (stage) stage.resize();
    }

    function onResize() {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(refresh, 150);
    }

    function onWindowLoad() {
      refresh();
    }

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(refresh);
    }

    /* Theme Editor：选中 Tab / Banner block 时自动切到对应面板 */
    function activateFromNode(node) {
      if (!node) return;
      if (stage) {
        var staged = stage.indexOfNode(node);
        if (staged >= 0) {
          activate(staged);
          return;
        }
      }
      var panel = node.closest ? node.closest('[data-fits-panel]') : null;
      if (!panel) return;
      var index = parseInt(panel.getAttribute('data-fits-panel-index'), 10);
      if (!isNaN(index)) activate(index);
    }

    function onBlockSelect(event) {
      if (root.contains(event.target)) activateFromNode(event.target);
    }

    function destroy() {
      if (destroyed) return;
      destroyed = true;
      window.clearTimeout(resizeTimer);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('load', onWindowLoad);
      document.removeEventListener('shopify:block:select', onBlockSelect);

      if (stage) stage.destroy();
      banners.forEach(function (banner) {
        if (banner) banner.destroy();
      });
      tabs.forEach(function (tab, i) {
        tab.removeEventListener('click', tabClickHandlers[i]);
        if (tab.parentNode) tab.parentNode.removeChild(tab);
      });
      panels.forEach(function (panel) {
        panel.classList.remove('is-active');
        panel.removeAttribute('aria-hidden');
        panel.removeAttribute('aria-labelledby');
        panel.removeAttribute('data-fits-panel-index');
      });
      if (indicator) indicator.style.transform = '';
      root.classList.remove('fits-js');
      root._fitsWellReady = false;
      root._fitsWellDestroy = null;
    }

    window.addEventListener('resize', onResize);
    window.addEventListener('load', onWindowLoad);
    document.addEventListener('shopify:block:select', onBlockSelect);
    root._fitsWellDestroy = destroy;

    activate(0);
    refresh();
    return destroy;
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-fits-well]');
    for (var i = 0; i < roots.length; i++) initSection(roots[i]);
  }

  function findRoot(target) {
    if (!target) return null;
    if (target.matches && target.matches('[data-fits-well]')) return target;
    return target.querySelector ? target.querySelector('[data-fits-well]') : null;
  }

  function onSectionLoad(event) {
    var root = findRoot(event.target);
    if (root) initSection(root);
  }

  function onSectionUnload(event) {
    var root = findRoot(event.target);
    if (root && root._fitsWellDestroy) root._fitsWellDestroy();
  }

  window[MODULE_KEY] = { initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', onSectionLoad);
  document.addEventListener('shopify:section:unload', onSectionUnload);
})();
